import btnClose from '@/components/btnClose/btnClose.vue'
import CustomInput from '@/components/CustomInput/CustomInput.vue'
import facebookLogin from 'facebook-login-vuejs';
import InfoMessage from "../../AlertMessage/InfoMessage.vue";
import Preloader from "../../Preloader/Preloader.vue";
import VueRecaptcha from 'vue-recaptcha';
import { mapActions } from 'vuex'
export default {
    name: 'signUpModal',
    props: {
        nonModal: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            form_data: [
                {
                    id: 0,
                    field: 'first_name',
                    value: '',
                    empty: true,
                    validity: true
                },
                {
                    id: 1,
                    field: 'last_name',
                    value: '',
                    empty: true,
                    validity: true
                },
                {
                    id: 2,
                    field: 'email',
                    value: '',
                    empty: true,
                    validity: true
                },
                {
                    id: 3,
                    field: 'password',
                    value: '',
                    empty: true,
                    validity: true
                },
                {
                    id: 4,
                    field: 'c_password',
                    value: '',
                    empty: true,
                    validity: true
                }
            ],
            errors: [],
            errorAuth: false,
            successAuth: false,
            preloading: false,
            isEnabledRecaptcha: eval(process.env.VUE_APP_RECAPTCHA_ENABLED),
            sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
            grecaptcha: '',
        }
    },
    components: {
        btnClose,
        CustomInput,
        facebookLogin,
        InfoMessage,
        Preloader,
        VueRecaptcha
    },
    methods: {
        ...mapActions(['changeVisionSignUp', 'changeVisionLogin', 'resetError']),
        async getUserData() {
            return await this.$store.dispatch('loginFB', this.FB).then(resp => {
                if (resp.status === 401) {
                    this.errorAuth = true
                } else {
                    this.errorAuth = false
                    this.successAuth = true
                    this.$router.push('/my-gates')
                }
            })
        },
        getField(field_name) {
            return this.form_data.find(v => v.field === field_name)
        },
        inputField(field_name, value) {
            let field = this.form_data.find(v => v.field === field_name)
            field.value = value.inp
            field.empty = value.inp.length === 0
            field.validity = !value.invalide
            if (field_name === 'c_password') {
                field.validity = !value.invalide && field.value === this.getField('password').value
            }
        },
        getError(field_name) {
            return this.errors.find(v=> v.field === field_name)
        },
        removeErrorByField(field_name) {
            const errorObjIndex = this.errors.indexOf(this.getError(field_name))
            if (errorObjIndex !== -1) {
                this.errors.splice(errorObjIndex, 1)
            }
        },
        toSuccess() {
            this.$store.dispatch('hideAllModals').then(()=>{})
        },
        changeVision() {
            this.changeVisionSignUp()
        },
        toLogin() {
            if (!this.$props.nonModal) {
                this.resetError()
                this.changeVisionSignUp()
                this.changeVisionLogin()
            } else {
                this.$router.push('/login');
            }
        },
        submitHandler() {
            this.preloading = true
            if (this.checkFields && this.isCaptureValid) {
                const formData = {
                    first_name: this.getField('first_name').value,
                    last_name: this.getField('last_name').value,
                    email: this.getField('email').value,
                    password: this.getField('password').value,
                    c_password: this.getField('c_password').value,
                }
                if (this.isEnabledRecaptcha) {
                    formData.grecaptcha = this.grecaptcha
                }
                this.$store.dispatch('registration_v2', formData)
                    .then(resp => {
                        this.resetCaptchaToken()
                        this.preloading = false
                        if (resp.status === 200) {
                            this.successAuth = true
                            this.toSuccess()
                            this.preloading = false
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event' : 'sign_up',
                                'method' : 'email',
                                'userId' : localStorage.getItem('user') ? localStorage.getItem('user')['id'] : null
                            });
                            this.$router.push('/please-activate')
                        }
                    })
                    .catch(error => {
                        this.preloading = false
                        Object.keys(error.response.data.errors).forEach(v => {
                            if (this.getField(v)) {
                                this.errors.push({
                                    field: v,
                                    message: error.response.data.errors[v][0]
                                })
                            }
                        })
                    })
            } else {
                this.errorAuth = true
            }
        },
        verify(recaptchaToken) {
            this.grecaptcha = recaptchaToken;
        },
        onCaptchaReset() {
            if (this.isEnabledRecaptcha) {
                this.$refs.recaptcha.reset()
                this.resetCaptchaToken()
            }
        },
        resetCaptchaToken() {
            localStorage.removeItem('_grecaptcha')
            this.grecaptcha = '';
        }
    },

    watch: {
        first_name () {
            this.removeErrorByField('first_name')
        },
        last_name () {
            this.removeErrorByField('last_name')
        },
        email () {
            this.removeErrorByField('email')
        },
        password () {
            this.removeErrorByField('password')
        },
        c_password () {
            this.removeErrorByField('c_password')
        }
    },
    computed: {
        first_name () {
            return this.getField('first_name').value
        },
        last_name () {
            return this.getField('last_name').value
        },
        email () {
            return this.getField('email').value
        },
        password () {
            return this.getField('password').value
        },
        c_password () {
            return this.getField('c_password').value
        },
        checkFields() {
           return !this.form_data.find(v => (!v.validity || v.empty))
        },
        isCaptureValid() {
            if (this.isEnabledRecaptcha && this.grecaptcha.length > 0) {
                return true
            }
            return !this.isEnabledRecaptcha;

        },
        toogleLogin() {
            return this.$store.getters.toogleLogin
        }
    }
}
